import React, { useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import ReducerConstants from '../../../_shared/constants/reducers';
import UserService from '../../../services/UserService';
import MixpanelService from '../../../services/MixpanelService';
import NegotiationService from '../../../services/NegotiationService';
import MixpanelConfig from '../../../_shared/constants/mixpanelConfig';
import { BidSource } from '../../../_shared/types/auction';
import TutorialNegotiationModal from '../../Modal/TutorialNegotiationModal';
import NegotiationModalContainer from '../../Modal/NegotiationModalContainer';
import { TradeContext } from '../../../_shared/types/trade';
import NegotiationErrorModalContainer from './NegotiationErrorModalContainer';
import useNegotiationTutorialVariant from '../../../_shared/hooks/trade/useNegotiationTutorialVariant';

const StartNegotiationContainer = ({
  trade,
  tradeDetails,
  Button,
  isOmp = false
}) => {
  const userService = UserService.get();
  const mixpanel = MixpanelService.get();
  const user = useSelector(
    state => state[ReducerConstants.AUTH]?.user,
    shallowEqual
  );

  const [
    tutorialNegotiationModalIsOpen,
    setTutorialNegotiationModalIsOpen
  ] = useState(false);
  const [negotiationModalIsOpen, setNegotiationModalIsOpen] = useState(false);
  const [
    isNegotiationErrorModalOpen,
    setIsNegotiationErrorModalOpen
  ] = useState(false);
  const [negotiationErrorMessage, setNegotiationErrorMessage] = useState(null);

  const tradeContext = trade.isSelling ? TradeContext.Sell : TradeContext.Buy;

  const { negotiationState, sellingNetworkId } = trade;
  const [, tutorialVariant] = useNegotiationTutorialVariant(
    tradeContext,
    negotiationState,
    sellingNetworkId,
    trade?.associatedTradeId,
    trade?.isInternalTrade
  );

  const onOpenNegotiationModal = () => {
    if (trade?.isInternalTrade) {
      setTutorialNegotiationModalIsOpen(true);
    } else {
      const negotiationService = NegotiationService.get();
      negotiationService.getNegotiationMessage(
        trade?.associatedTradeId,
        tradeContext,
        setNegotiationErrorMessage,
        setIsNegotiationErrorModalOpen,
        setTutorialNegotiationModalIsOpen
      );
    }

    mixpanel.track(MixpanelConfig.names.negotiate, {
      user_type: userService.isSeller(user, trade?.dealer?.id)
        ? MixpanelConfig.userType.seller
        : MixpanelConfig.userType.buyer,
      source: BidSource.VDP_OVERLAY,
      trade_id: trade?.id,
      auction_id: trade?.auctionId
    });
  };
  const onCloseTutorialNegotiationModal = () => {
    setTutorialNegotiationModalIsOpen(false);
  };
  const onStartNegotiation = () => {
    setTutorialNegotiationModalIsOpen(false);
    setNegotiationModalIsOpen(true);
  };
  const onCloseNegotiationModal = () => {
    setNegotiationModalIsOpen(false);
  };

  return (
    <>
      <Button onClick={onOpenNegotiationModal} />
      {isNegotiationErrorModalOpen ? (
        <NegotiationErrorModalContainer
          isNegotiationErrorModalOpen={isNegotiationErrorModalOpen}
          negotiationErrorMessage={negotiationErrorMessage}
          setIsNegotiationErrorModalOpen={setIsNegotiationErrorModalOpen}
          tradeId={trade?.id}
          tradeDetails={tradeDetails}
          auctionId={trade?.auctionId}
        />
      ) : (
        <TutorialNegotiationModal
          modalIsOpen={tutorialNegotiationModalIsOpen}
          onClose={onCloseTutorialNegotiationModal}
          onStartNegotiation={onStartNegotiation}
          variant={tutorialVariant}
          isOmp={isOmp}
        />
      )}
      <NegotiationModalContainer
        trade={trade}
        modalIsOpen={negotiationModalIsOpen}
        tradeContext={tradeContext}
        onClose={onCloseNegotiationModal}
        isOmp={isOmp}
      />
    </>
  );
};

export default StartNegotiationContainer;
